import { ApiErrorPageWithTrans } from '@components/Error/ApiErrorPageWithTrans';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { NoddiLoadingScreenWithTrans } from '@components/Loading/NoddiLoadingScreenWithTrans';
import { t } from '@lingui/core/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { customerRoutes } from 'noddi-util';
import { Navigate, useParams } from 'react-router-dom';
import { FeedbackToBooking } from './FeedbackToBooking';

export const FeedbackForBooking = () => {
  const { slug } = useParams();

  const {
    data: booking,
    isPending: isBookingPending,
    error: bookingError
  } = noddiAsync.useGet({
    type: URLKeys.getBookingInfo,
    input: { slug: slug! }
  });

  if (isBookingPending) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (bookingError) {
    return <ApiErrorPageWithTrans error={[bookingError]} />;
  }

  if (booking.serviceFeedback) {
    return <Navigate to={customerRoutes.bookingInfo.getPath({ slug: slug! })} />;
  }

  return (
    <ContentWrapperCustomerApp
      title={t`How was your experience?`}
      backButtonPath={customerRoutes.bookingInfo.getPath({ slug: booking.slug })}
      className='max-w-3xl'
    >
      <FeedbackToBooking booking={booking} />
    </ContentWrapperCustomerApp>
  );
};
